/* eslint-disable no-unused-expressions */
import { useKey } from 'react-use';

import { isLeftArrowKey, isRightArrowKey } from '../helpers/keys';

const useKeyboardControlForIndexedItems = ({
  isEnabled = false,
  numberOfItems = 0,
  selectedIndex,
  setSelectedIndex,
}) => {
  useKey(
    key => isRightArrowKey(key),
    event => {
      if (
        isEnabled &&
        !!numberOfItems &&
        !!setSelectedIndex &&
        typeof selectedIndex !== 'undefined'
      ) {
        event.preventDefault();
        const nextIndex = selectedIndex + 1;

        // If user presses right, move to next index. If at end of the list,
        // select the first item instead.
        if (nextIndex >= numberOfItems) {
          setSelectedIndex(0);
        } else {
          setSelectedIndex(nextIndex);
        }
      }
    },
    { event: 'keydown' }
  );

  useKey(
    key => isLeftArrowKey(key),
    event => {
      if (
        isEnabled &&
        !!numberOfItems &&
        !!setSelectedIndex &&
        typeof selectedIndex !== 'undefined'
      ) {
        event.preventDefault();
        const previousIndex = selectedIndex - 1;

        // If user presses left, move to previous index. If at start of the
        // list, select the last item instead.
        if (previousIndex < 0) {
          setSelectedIndex(numberOfItems - 1);
        } else {
          setSelectedIndex(previousIndex);
        }
      }
    },
    { event: 'keydown' }
  );
};

export default useKeyboardControlForIndexedItems;
